import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const SubstractIcon = createIcon({
  displayName: 'SubstractIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g xmlns="http://www.w3.org/2000/svg" fill="none">
        <path d="M24 0v24h-24v-24h24Z" />
        <path d="M0 24v-24h24v24h-24Z" />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M11 8v-1.667c0-.736.597-1.333 1.333-1.333h5.333c.737 0 1.334.597 1.334 1.333v5.333c0 .737-.597 1.334-1.333 1.334h-1.667"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M5 17.667v-5.333c0-.737.597-1.334 1.333-1.334h5.333c.737 0 1.334.597 1.334 1.333v5.333c0 .737-.597 1.334-1.333 1.334h-5.334c-.736 0-1.333-.597-1.333-1.333Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M2.77 9.538c.88-3.298 3.47-5.888 6.768-6.768"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M15.198 21c2.708-.961 4.841-3.094 5.802-5.802"
        />
      </g>
    </>
  ),
})

const Substract: FC<IconProps> = (props) => {
  return <CustomIcon as={SubstractIcon} {...props} />
}

export default memo(Substract)
